import { createContext, ReactNode, useCallback, useContext, useState } from 'react';
import { Typography } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import { Modal } from 'framework/ui/ui-builder';

const ArtifactRestoreDialogContext = createContext<(message: string) => void>(() => {});

export const ArtifactRestoreDialogProvider = ({ children }: { children: ReactNode }) => {
  const [message, setMessage] = useState<string>();
  const showRestoreDialog = useCallback((nextMessage: string) => {
    setMessage(nextMessage);
  }, []);

  return (
    <ArtifactRestoreDialogContext.Provider value={showRestoreDialog}>
      {children}
      <Modal
        isOpen={Boolean(message)}
        title="Archived file"
        hasCancelButton={false}
        onToggle={() => setMessage(undefined)}
        buttons={[
          <Button key="ok" onClick={() => setMessage(undefined)}>
            OK
          </Button>,
        ]}
      >
        <Typography variant="body1" color="textPrimary">
          {message}
        </Typography>
      </Modal>
    </ArtifactRestoreDialogContext.Provider>
  );
};

export const useArtifactRestoreDialog = () => useContext(ArtifactRestoreDialogContext);
